import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

const points = [
  {
    title: "PHI never leaves your warehouse",
    description:
      "Preset queries your database directly and returns results in real time. No data is extracted, copied, or cached outside your security perimeter.",
  },
  {
    title: "Only metadata lives in Preset",
    description:
      "Dashboard definitions, chart configurations, and user permissions — that's all Preset stores. Your actual data stays exactly where it is.",
  },
  {
    title: "Your security controls stay in charge",
    description:
      "Database-level permissions, VPC rules, and network policies continue to govern access. Preset operates within the boundaries you've already set.",
  },
]

function ArchitectureSection() {
  return (
    <section className="bg-big-stone py-20">
      <Container>
        <Heading
          label="Zero-Copy Architecture"
          title="Your PHI Stays Where It Belongs"
          subtitle="Most BI tools ingest and store your data in their own infrastructure — creating another attack surface and another system to audit. Preset is different. We query your data in place and never store PHI."
          decoration="border"
          inverted
        />
        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {points.map((point) => (
            <div key={point.title}>
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-xl bg-lush/20">
                <svg
                  className="h-5 w-5 text-lush"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h3 className="mb-2 text-xl font-bold text-white">
                {point.title}
              </h3>
              <p className="text-base text-sage">{point.description}</p>
            </div>
          ))}
        </div>
        <p className="mt-10 text-sm text-sage/70">
          Query result caching (AWS Elasticache) uses workspace-specific AES-128
          encryption and expires after 24 hours by default. Caching can be
          disabled entirely for sensitive datasets.
        </p>
      </Container>
    </section>
  )
}

export default ArchitectureSection
